export const DSHBRD = {
  TBL_HDR_HDNG: {
    color: "white",
    fontWeight: 600,
    textAlign: "center",
    backgroundColor: "#5A67D8",
    fontFamily: '"Poppins",serif',
  },

  TBL_HDR_VLU: { textAlign: "center", fontFamily: '"Poppins",serif' },
  SRCH_BTNS: {
    width: "110px",
    fontWeight: "600",
    backgroundColor: "#5A67D8",
    fontFamily: '"Poppins",serif',
  },
  BLNK: {
    width: "700px",
    height: "450px",
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    padding: "20px",
    textAlign: "center",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  },
  FNTS: { fontFamily: '"Poppins", serif' },
};
